export default __webpack_public_path__ + "static/inside-c2023f5de73f7588fa969da1485b5833.png";